// =====================================
//
//   簡易圖片player
//   Author: Gray
//   createtime: 2017 / 11 / 01
//   updatetime: 2017 / 11 / 01
//
// =====================================

window.InifECApp.directive('simpleImagePlayer', ['$rootScope', '$ngModal', '$timeout',
	function ($rootScope, $ngModal, $timeout) {

		var _dir = {};

		var controller = ['$scope', function($scope) {

            // ===============================
            //  開啟 modal
            // ===============================
            var openModal = function() {

            	$ngModal.openModal('simple-image-player-modal');
            }

            // ===============================
            //  關閉 modal
            // ===============================
            var closeModal = function() {

            	$ngModal.closeModal('simple-image-player-modal');
            }

            /*==========================
                Events
            ==========================*/            
            $scope.$on('OPEN_SIMPLE_IMAGE_PLAYER_MODAL', function(event, data) {
                    
                if(data) {
                    $scope.imageurl = data.imageurl;
                    $scope.annotation = data.annotation;

                    openModal();
                }
            });

            /*==========================
                Members
            ==========================*/
            $scope.imageurl;
            $scope.annotation;

            /*==========================
                Methods
            ==========================*/

            /*==========================
                init
            ==========================*/
            
		}]

		_dir.restrict = "E";
		_dir.scope = true;
		_dir.templateUrl = "partials/modal/simple_image_player.html";
		_dir.controller = controller;

		return _dir;
	}]
);